<template>
  <div class="mb">
    <div class="login_con">
      <!-- <p class="title">设备码</p> -->
      <input type="text" class="input" placeholder="请输入小程序生成的设备码" v-model="login_key"/>
      <div class="btn_login flex_cen" @click="startLogin" v-loading="login_bz">立即登录</div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      login_key:'',
      login_bz:false,//节流标志
    }
  },
  mounted() {
    console.log("123");
  },
  methods:{
    startLogin(){
      if(this.login_bz)return
      if(!this.login_key){
        this.$message({
          message: '请输入设备码',
          type: 'warning'
        });
        return
      }
      this.login_bz = true
      let url = this.$store.state.app_api + this.$store.state.app_url.checkPcKey;
      this.$request.postHttp({ key: this.login_key }, url, (response) => {
        console.log("key", response);
        if(response.rc === '3100'){
          setTimeout(()=>{
            this.$message({
              message: '当前设备码无效，请前往小程序重新生成',
              type: 'warning'
            });
            this.login_bz = false
          },1000)
          return
        }
        this.login_bz = false
        // this.$store.commit('setUid',response.model.uid)
        // this.$store.commit('setQd',response.model.qd)
        // this.$store.commit("setLoginState", true);
        // this.$store.commit("setShowLogin", false);
        this.$globalFun.getUserInfo(this);
      });
    }
  }
};
</script>
<style scoped>
.btn_login{
  width: 262px;
  height: 40px;
  background: #74B9FF;
  border-radius: 8px;
  color:#fff;
  cursor: pointer;
}
.title{
  width:100%;
  text-align:center;
  font-size: 16px;
  font-weight: bold;
}
.input{
  width: 262px;
  height: 40px;
  background-color: #EEEEEE;
  border-radius: 8px;
  padding: 0 20px;
  box-sizing: border-box;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
.login_con{
  width: 400px;
  height: 240px;
  background-color: #fff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 32px;
}
.mb {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2000;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue